(function initGamingHomepage() {
  if (!document.body.classList.contains("template-index")) {
    return;
  }

  injectPageDecor();
  bootWorldCarousel();
  injectBenefitsArena();
  injectProductArena();
  injectFooterArena();
  knockOutIconBackgrounds();
  bootImageAccordion();
})();

function bootImageAccordion() {
  document.querySelectorAll(".template-index .image-with-text").forEach((section) => {
    const parallaxImage = section.querySelector("image-parallax img, image-parallax .placeholder-svg");
    if (parallaxImage) {
      parallaxImage.getAnimations().forEach((animation) => animation.cancel());
      parallaxImage.style.transform = "none";
    }

    const tabs = Array.from(section.querySelectorAll("[is='collapsible-block']"));
    if (!tabs.length) {
      return;
    }

    tabs.forEach((tab) => {
      const summary = tab.querySelector("summary");
      if (!summary) {
        return;
      }

      summary.addEventListener(
        "click",
        () => {
          tabs.forEach((other) => {
            if (other === tab) {
              return;
            }

            const content = other.querySelector(".collapsible-content");
            if (content) {
              content.getAnimations().forEach((animation) => animation.cancel());
              content.style.display = "none";
              content.style.height = "";
              content.style.overflow = "";
              content.style.marginTop = "";
              content.style.marginBottom = "";
              content.style.paddingTop = "";
              content.style.paddingBottom = "";
            }

            other.removeAttribute("open");
            other.classList.remove("active");
            other.setAttribute("aria-expanded", "false");
          });
        },
        true
      );
    });
  });
}

function bootWorldCarousel() {
  const mount = () => {
    const existing = document.querySelector(".template-index .testimonials .testimonials-world");
    if (existing && existing.dataset.worldReady === "true") {
      return true;
    }

    const root = document.querySelector(".template-index .testimonials slideshow-section");
    if (!root) {
      return Boolean(existing);
    }

    const wrapper = root.querySelector(".swiper-wrapper");
    if (!wrapper) {
      return false;
    }

    wrapper.querySelectorAll(".swiper-slide-duplicate").forEach((duplicate) => {
      duplicate.remove();
    });

    const slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
    if (slides.length < 2) {
      return false;
    }

    if (root.globalSlide) {
      try {
        root.globalSlide.destroy(true, true);
      } catch (error) {
        void error;
      }
      root.globalSlide = null;
    }

    root.init = function noopInit() {};
    root.initSlide = function noopInitSlide() {};
    root.resizeSlider = function noopResize() {};

    const stage = document.createElement("div");
    stage.className = "testimonials-world";
    stage.dataset.worldReady = "true";
    while (root.firstChild) {
      stage.appendChild(root.firstChild);
    }
    root.replaceWith(stage);

    const section = stage.closest(".testimonials");
    if (section) {
      injectTestimonialsArena(section);
    }

    const platform = document.createElement("div");
    platform.className = "testimonials-world__platform";
    platform.setAttribute("aria-hidden", "true");
    stage.insertBefore(platform, stage.firstChild);

    wrapper.classList.add("testimonials-world__ring");
    wrapper.style.setProperty("--count", String(slides.length));

    const actions = stage.querySelector(".swiper-actions");
    const controls = document.createElement("div");
    controls.className = "testimonials-world__controls";
    if (actions) {
      actions.classList.add("testimonials-world__nav");
      actions.classList.remove("hidden");
      controls.appendChild(actions);
    }

    const dots = document.createElement("div");
    dots.className = "testimonials-world__dots";
    dots.setAttribute("role", "tablist");
    slides.forEach((_, index) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "testimonials-world__dot";
      dot.setAttribute("aria-label", "Atsiliepimas " + String(index + 1));
      dot.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        snapTo(index);
      });
      dots.appendChild(dot);
    });
    controls.appendChild(dots);
    stage.appendChild(controls);

    const step = 360 / slides.length;
    slides.forEach((slide, index) => {
      slide.style.setProperty("--i", String(index));
      slide.classList.add("testimonials-world__card");
      slide.style.setProperty(
        "transform",
        "rotateY(" + index * step + "deg) translateZ(var(--world-radius)) translateY(-50%)",
        "important"
      );
    });

    let activeIndex = 0;
    let rotation = 0;
    let dragStartX = 0;
    let dragStartRotation = 0;
    let dragging = false;

    const isFlat = () => window.matchMedia("(max-width: 1024.98px)").matches;

    const applyRotation = (withTransition) => {
      const flat = isFlat();
      stage.classList.toggle("is-flat", flat);

      if (flat) {
        wrapper.style.transition = "none";
        wrapper.style.setProperty("transform", "none", "important");
      } else {
        wrapper.style.transition = withTransition
          ? "transform 0.85s cubic-bezier(0.22, 1, 0.36, 1)"
          : "none";
        wrapper.style.setProperty(
          "transform",
          "rotateX(6deg) rotateY(" + rotation + "deg)",
          "important"
        );
      }

      slides.forEach((slide, index) => {
        const offset = Math.abs((((index - activeIndex) % slides.length) + slides.length) % slides.length);
        const mirrored = Math.min(offset, slides.length - offset);
        slide.classList.toggle("is-active", index === activeIndex);
        slide.setAttribute("aria-hidden", index === activeIndex ? "false" : "true");
        slide.style.setProperty("--depth", String(mirrored));
        if (flat) {
          slide.style.setProperty("transform", "none", "important");
        } else {
          slide.style.setProperty(
            "transform",
            "rotateY(" + index * step + "deg) translateZ(var(--world-radius)) translateY(-50%)",
            "important"
          );
        }
      });
      stage.querySelectorAll(".testimonials-world__dot").forEach((dot, index) => {
        dot.classList.toggle("is-active", index === activeIndex);
        dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
      });
    };

    const snapTo = (index) => {
      const total = slides.length;
      activeIndex = ((index % total) + total) % total;
      const targetBase = -activeIndex * step;
      const turns = Math.round((rotation - targetBase) / 360);
      rotation = targetBase + turns * 360;
      applyRotation(true);
    };

    const onPointerDown = (event) => {
      if (event.target.closest("button, a")) {
        return;
      }
      dragging = true;
      dragStartX = event.clientX;
      dragStartRotation = rotation;
      wrapper.style.transition = "none";
      stage.classList.add("is-dragging");
      stage.setPointerCapture(event.pointerId);
    };

    const onPointerMove = (event) => {
      if (!dragging || isFlat()) {
        return;
      }
      const delta = event.clientX - dragStartX;
      rotation = dragStartRotation + delta * 0.28;
      applyRotation(false);
    };

    const onPointerUp = (event) => {
      if (!dragging) {
        return;
      }
      dragging = false;
      stage.classList.remove("is-dragging");
      try {
        stage.releasePointerCapture(event.pointerId);
      } catch (error) {
        void error;
      }
      if (isFlat()) {
        const delta = event.clientX - dragStartX;
        if (delta < -40) {
          snapTo(activeIndex + 1);
        } else if (delta > 40) {
          snapTo(activeIndex - 1);
        } else {
          snapTo(activeIndex);
        }
        return;
      }
      snapTo(Math.round(-rotation / step));
    };

    stage.addEventListener("pointerdown", onPointerDown);
    stage.addEventListener("pointermove", onPointerMove);
    stage.addEventListener("pointerup", onPointerUp);
    stage.addEventListener("pointercancel", onPointerUp);

    const prev = stage.querySelector(".swiper-button-prev");
    const next = stage.querySelector(".swiper-button-next");
    if (prev) {
      prev.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        snapTo(activeIndex - 1);
      });
    }
    if (next) {
      next.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        snapTo(activeIndex + 1);
      });
    }

    window.addEventListener("resize", () => {
      applyRotation(false);
    });

    snapTo(0);
    return true;
  };

  if (mount()) {
    return;
  }

  const ready = () => {
    if (mount()) {
      return;
    }
    window.setTimeout(ready, 80);
  };

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("slideshow-section").then(ready);
  } else {
    ready();
  }
}

function laserTargetSvg() {
  return '<svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="40" cy="40" r="28" stroke="#22e0ff" stroke-width="3"/><circle cx="40" cy="40" r="16" stroke="#8b5cff" stroke-width="3"/><circle cx="40" cy="40" r="5" fill="#22e0ff"/><path d="M40 6v12M40 62v12M6 40h12M62 40h12" stroke="#4f8cff" stroke-width="3" stroke-linecap="round"/></svg>';
}

function injectPageDecor() {
  const layout = document.querySelector(".template-index .content-for-layout");
  if (!layout || layout.querySelector(".gaming-page-decor")) {
    return;
  }

  const decor = document.createElement("div");
  decor.className = "gaming-page-decor";
  decor.setAttribute("aria-hidden", "true");
  decor.innerHTML =
    '<div class="gaming-page-decor__wash gaming-page-decor__wash--a"></div>' +
    '<div class="gaming-page-decor__wash gaming-page-decor__wash--b"></div>' +
    '<div class="gaming-page-decor__wash gaming-page-decor__wash--c"></div>' +
    '<div class="gaming-page-decor__mark gaming-page-decor__mark--a">' +
    laserTargetSvg() +
    "</div>" +
    '<div class="gaming-page-decor__mark gaming-page-decor__mark--b">' +
    laserTargetSvg() +
    "</div>" +
    '<div class="gaming-page-decor__mark gaming-page-decor__mark--c">' +
    laserTargetSvg() +
    "</div>" +
    '<div class="gaming-page-decor__mark gaming-page-decor__mark--d">' +
    laserTargetSvg() +
    "</div>";
  layout.prepend(decor);
}

function injectTestimonialsArena(section) {
  if (section.querySelector(".testimonials-arena")) {
    return;
  }

  const arena = document.createElement("div");
  arena.className = "testimonials-arena";
  arena.setAttribute("aria-hidden", "true");

  const glow = document.createElement("div");
  glow.className = "testimonials-arena__glow";
  const vignette = document.createElement("div");
  vignette.className = "testimonials-arena__vignette";

  const floaterLeft = document.createElement("div");
  floaterLeft.className = "testimonials-arena__floater testimonials-arena__floater--left";
  floaterLeft.innerHTML = "<span>Laser</span><span>Tag</span><span>Arena</span>";

  const floaterRight = document.createElement("div");
  floaterRight.className = "testimonials-arena__floater testimonials-arena__floater--right";
  floaterRight.innerHTML =
    '<div class="testimonials-arena__icon">' +
    laserTargetSvg() +
    "</div><span>Lock</span><span>On</span>";

  const targetLeft = document.createElement("div");
  targetLeft.className = "testimonials-arena__prop testimonials-arena__prop--target-left";
  targetLeft.innerHTML = laserTargetSvg();

  const targetRight = document.createElement("div");
  targetRight.className = "testimonials-arena__prop testimonials-arena__prop--target-right";
  targetRight.innerHTML = laserTargetSvg();

  arena.append(glow, vignette, floaterLeft, floaterRight, targetLeft, targetRight);
  section.appendChild(arena);
}

function benefitIconSvgs() {
  return [
    laserTargetSvg(),
    '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="6" stroke="#22e0ff" stroke-width="2.4"/><circle cx="32" cy="16" r="6" stroke="#8b5cff" stroke-width="2.4"/><path d="M8 36c1.4-6 5-9 8-9s6.6 3 8 9" stroke="#22e0ff" stroke-width="2.4" stroke-linecap="round"/><path d="M24 36c1.4-6 5-9 8-9s6.6 3 8 9" stroke="#8b5cff" stroke-width="2.4" stroke-linecap="round"/></svg>',
    '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 6l5 12.4L42 20l-10 8.2L35 42 24 34.6 13 42l3-13.8L6 20l13-1.6L24 6z" stroke="#22e0ff" stroke-width="2.4" stroke-linejoin="round"/></svg>',
    '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 22h28v16a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V22z" stroke="#8b5cff" stroke-width="2.4"/><path d="M10 22c0-6 6-10 14-10s14 4 14 10" stroke="#22e0ff" stroke-width="2.4"/><path d="M24 8v6" stroke="#22e0ff" stroke-width="2.4" stroke-linecap="round"/><circle cx="24" cy="7" r="2.2" fill="#22e0ff"/></svg>'
  ];
}

function injectBenefitsArena() {
  const section = document.querySelector(".template-index .benefits");
  if (!section || section.querySelector(".benefits-arena")) {
    return;
  }

  const arena = document.createElement("div");
  arena.className = "benefits-arena";
  arena.setAttribute("aria-hidden", "true");
  arena.innerHTML =
    '<div class="benefits-arena__glow"></div>' +
    '<div class="benefits-arena__vignette"></div>' +
    '<div class="benefits-arena__floater benefits-arena__floater--tl"><span>Play</span><span>Laser</span><span>Live</span><span>More</span></div>' +
    '<div class="benefits-arena__floater benefits-arena__floater--tr"><span>Real People</span><span>Real Emotions</span></div>' +
    '<div class="benefits-arena__floater benefits-arena__floater--bl"><span>Laser</span><span>Arena</span></div>' +
    '<div class="benefits-arena__floater benefits-arena__floater--br"><span>Good Games</span><span>Happier People</span></div>' +
    '<div class="benefits-arena__mark benefits-arena__mark--left">' +
    laserTargetSvg() +
    "</div>" +
    '<div class="benefits-arena__mark benefits-arena__mark--right">' +
    laserTargetSvg() +
    "</div>" +
    '<div class="benefits-arena__platform"><span>Team / Play / Win / Repeat</span></div>';
  section.appendChild(arena);

  const heading = section.querySelector(".benefits__benefit-heading");
  if (heading && !heading.parentNode.querySelector(".benefits-arena__kicker")) {
    const kicker = document.createElement("p");
    kicker.className = "benefits-arena__kicker";
    kicker.textContent = "Kodėl rinktis mus?";
    heading.parentNode.insertBefore(kicker, heading);

    const sub = document.createElement("p");
    sub.className = "benefits-arena__sub";
    sub.textContent = "Kuriame nepamirštamus potyrius kiekvienam žaidėjui.";
    heading.after(sub);
  }

  const mobileHead = section.querySelector(".hidden-1025");
  if (mobileHead && !mobileHead.querySelector(".benefits-arena__kicker")) {
    const kicker = document.createElement("p");
    kicker.className = "benefits-arena__kicker";
    kicker.textContent = "Kodėl rinktis mus?";
    mobileHead.insertBefore(kicker, mobileHead.firstChild);

    if (!mobileHead.querySelector(".benefits-arena__sub")) {
      const sub = document.createElement("p");
      sub.className = "benefits-arena__sub";
      sub.textContent = "Kuriame nepamirštamus potyrius kiekvienam žaidėjui.";
      mobileHead.appendChild(sub);
    }
  }

  const icons = benefitIconSvgs();
  section.querySelectorAll(".grid-cols .benefits__benefit").forEach((card, index) => {
    if (card.querySelector(".benefits__icon")) {
      return;
    }
    const row = card.querySelector(".flex.align-center");
    if (!row) {
      return;
    }
    const icon = document.createElement("span");
    icon.className = "benefits__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = icons[index % icons.length];
    row.insertBefore(icon, row.firstChild);
  });
}

function injectProductArena() {
  const product = document.querySelector(".template-index .main-product");
  const section = product && product.closest(".shopify-section");
  if (!section || section.querySelector(".product-arena")) {
    return;
  }

  section.classList.add("product-arena-section");
  const prev = section.previousElementSibling;
  if (prev && prev.querySelector(".rich-text")) {
    prev.classList.add("product-arena-heading");
    const heading = prev.querySelector(".heading, h2");
    if (heading && !prev.querySelector(".product-arena__kicker")) {
      const kicker = document.createElement("p");
      kicker.className = "product-arena__kicker";
      kicker.textContent = "Rezervuok nuotykį";
      heading.parentNode.insertBefore(kicker, heading);
    }
  }

  const arena = document.createElement("div");
  arena.className = "product-arena";
  arena.setAttribute("aria-hidden", "true");
  arena.innerHTML =
    '<div class="product-arena__glow"></div>' +
    '<div class="product-arena__floater product-arena__floater--tl"><span>Team</span><span>Play</span><span>Win</span><span>Repeat</span></div>' +
    '<div class="product-arena__floater product-arena__floater--tr"><span>Good Games</span><span>Happier People</span></div>' +
    '<div class="product-arena__floater product-arena__floater--bl"><span>Laser</span><span>Arena</span></div>' +
    '<div class="product-arena__mark product-arena__mark--left">' +
    laserTargetSvg() +
    "</div>" +
    '<div class="product-arena__mark product-arena__mark--right">' +
    laserTargetSvg() +
    "</div>";
  section.appendChild(arena);
}

function injectFooterArena() {
  const footer = document.querySelector(".template-index .footer");
  if (!footer || footer.dataset.footerArena === "true") {
    return;
  }
  footer.dataset.footerArena = "true";

  const desktop = footer.querySelector(".footer__blocks--desktop");
  if (!desktop || footer.querySelector(".footer-arena__bar")) {
    return;
  }

  const bar = document.createElement("div");
  bar.className = "footer-arena__bar";

  const socials = document.createElement("div");
  socials.className = "footer-arena__socials";
  const seen = {};
  document.querySelectorAll("a[href*='facebook.com'], a[href*='instagram.com'], a[href*='tiktok.com']").forEach((link) => {
    const icon = link.querySelector("svg");
    if (!icon || seen[link.href] || socials.children.length >= 4) {
      return;
    }
    seen[link.href] = true;
    const item = document.createElement("a");
    item.href = link.href;
    item.target = "_blank";
    item.rel = "noopener";
    item.setAttribute("aria-label", link.getAttribute("aria-label") || "Social");
    item.appendChild(icon.cloneNode(true));
    socials.appendChild(item);
  });
  if (socials.children.length) {
    bar.appendChild(socials);
  }

  const sign = document.createElement("p");
  sign.className = "footer-arena__sign";
  sign.innerHTML = "See you in arena";
  bar.appendChild(sign);

  const reserve = document.querySelector("a[href*='rezerv' i]");
  const contacts = document.querySelector('.header a[href*="kontaktai" i], a.header__menu-button[href*="kontaktai" i]');
  const cta = document.createElement("a");
  cta.className = "footer-arena__cta";
  cta.href = (reserve && reserve.href) || (contacts && contacts.href) || "/";
  cta.textContent = "Play differently";
  bar.appendChild(cta);

  const shell = desktop.parentElement;
  if (shell) {
    shell.appendChild(bar);
  } else {
    desktop.appendChild(bar);
  }

  footer.querySelectorAll(".footer-block--menu").forEach((block) => {
    const heading = block.querySelector("h5, .h5, h2, .heading");
    if (heading && !heading.textContent.trim()) {
      heading.textContent = "Žaidėjo informacija";
    }
  });
}

function knockOutIconBackgrounds() {
  const cards = document.querySelectorAll(".template-index .footer-group .icon-with-text-columns .icon-with-text-columns__block");
  cards.forEach((card) => {
    const heading = (card.textContent || "").toLowerCase();
    if (heading.indexOf("dalyvi") === -1) {
      return;
    }

    const img = card.querySelector("img");
    if (!img || img.dataset.knockout === "true") {
      return;
    }

    img.classList.add("js-knockout-icon");
    card.classList.add("js-knockout-icon");
    img.style.objectFit = "contain";
    img.style.mixBlendMode = "lighten";

    const applyCanvas = (source) => {
      try {
        const canvas = document.createElement("canvas");
        const width = source.naturalWidth || 160;
        const height = source.naturalHeight || 160;
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(source, 0, 0);
        const imageData = ctx.getImageData(0, 0, width, height);
        const pixels = imageData.data;
        for (let i = 0; i < pixels.length; i += 4) {
          if (pixels[i] < 48 && pixels[i + 1] < 48 && pixels[i + 2] < 48) {
            pixels[i + 3] = 0;
          }
        }
        ctx.putImageData(imageData, 0, 0);
        img.src = canvas.toDataURL("image/png");
        img.style.mixBlendMode = "normal";
        img.dataset.knockout = "true";
      } catch (error) {
        img.style.mixBlendMode = "lighten";
      }
    };

    const probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.onload = function onIconLoad() {
      applyCanvas(probe);
    };
    probe.onerror = function onIconError() {
      img.style.mixBlendMode = "lighten";
    };
    probe.src = img.currentSrc || img.src;
  });
}
